const BANCONEXION_URL = 'https://login.portalempresas.bancochile.cl/bancochile-web/empresa/login/';

export default BANCONEXION_URL;
